import React, { useState, useEffect } from 'react';
import { Signal, Wifi, Battery } from 'lucide-react';

const StatusBar = () => {
  const [time, setTime] = useState('09:41');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime(now.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false }));
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="absolute top-0 left-0 w-full h-12 flex justify-between items-center px-6 text-[10px] font-medium text-white/80 z-50 pointer-events-none select-none safe-top mix-blend-overlay">
      <span>{time}</span>
      <div className="flex gap-1.5 items-center">
        <Signal size={12} />
        <Wifi size={12} />
        <Battery size={12} />
      </div>
    </div>
  );
};

export default StatusBar;
